require("./brokerConvenienceTestResultItem.scss");
const React = require("react");
const PropTypes = require("prop-types");

//  @constants
const { HYPHEN } = require("constants/index");

const { FormattedText } = require("core/i18n").i18n;

export default class BrokerConvenienceTestResultItem extends React.Component {
    render() {
        const { title, responses } = this.props;
        const isResponsesEmpty = responses.every((item) => item === null || item.description === null);
        return (
            <div className="br-convenience-test-accordion-item__container">
                <div className="br-convenience-test-accordion-item__icon-zone">
                    <div className="br-convenience-test-accordion-item__icon-check" />
                </div>
                <div className="br-convenience-test-accordion-item__info-zone">
                    <div className="br-convenience-test-accordion-item__subtitle">
                        {title}
                    </div>
                    <ul className="br-convenience-test-accordion-item__subitem-container">
                        {isResponsesEmpty && <FormattedText value={"broker-convenienceMifidTestSummary_empty_item"} />}
                        {responses &&
                            responses.map((res) => {
                                return (
                                    res &&
                                    res.description && (
                                        <li className="br-convenience-test-accordion-item__subitem">
                                            <div className="br-convenience-test-accordion-item__subitem-style-type">
                                                {HYPHEN}
                                            </div>
                                            <div>{res.description}</div>
                                        </li>
                                    )
                                );
                            })}
                    </ul>
                </div>
            </div>
        );
    }
}

BrokerConvenienceTestResultItem.propTypes = {
    title: PropTypes.string,
    responses: PropTypes.array,
};
